import getState from './global/state.js';
import { showToast } from './elements/toasts.js';

const eventsListBlockClass = 'Block--eventsList';

function requireAuthenticatedUser($element) {
  const registerUrl = getState('registerUrl');

  if ((!registerUrl) || (getState('user') === 'True')) {
    return true;
  }

  let message = 'Sorry, you cannot access this event at the moment.';
  const currentUrl = window.location.pathname + window.location.search;
  const loginUrl = getState('loginUrl');

  if (loginUrl || registerUrl) {
    message = `Please `;
    let loginUrlWithRedirect = loginUrl;
    if (loginUrlWithRedirect) {
      loginUrlWithRedirect += `?next=${currentUrl}`
    }
    let registerUrlWithRedirect = registerUrl;
    if (registerUrlWithRedirect) {
      registerUrlWithRedirect += `?next=${currentUrl}`
    }
    if (loginUrlWithRedirect) {
      message += `<a href="${loginUrlWithRedirect}">sign in</a> `;
      if (registerUrlWithRedirect) {
        message += `or <a href="${registerUrlWithRedirect}">register</a> `;
      }
    } else {
      message += `<a href="${registerUrlWithRedirect}">register</a> `;
    }
    message += 'to access the event.';
  }

  showToast(message, {
    iconUrl: '/static/images/ic-alert-circle-dark.svg'
  });
  return false;
}

export function initializeScheduleItemLinks() {
  const $element = document.querySelector(`.${eventsListBlockClass}`);

  if(!$element) {
    return;
  }

  $element.addEventListener('mouseover', (event) => {
    const registerUrl = getState('registerUrl');
    if ((!registerUrl) || (getState('user') === 'True')) {
      return;
    }
    const $target = event.target.closest('[class$="Item__Link--active"]');
    if (!$target || !$element.contains($target)) {
      return;
    }
    $target.setAttribute("href", "#");
  });

  $element.addEventListener('click', (event) => {
    const $target = event.target.closest('[class$="Item__Link--active"]');
    let click = true;
    if (!$target || !$element.contains($target)) {
      return;
    }
    if (requireAuthenticatedUser()) {
      click = false;
    }
    if (click) {
      event.preventDefault();
    }
  });
}
